const ProductRegistrationForm = (models) => ({
  models: [],
  selectedModel: "",
  assembledBy: "",
  purchaseLocation: "",
  isLoading: false,
  didSubmit: false,
  get selectedModelColors() {
    const model = this.models.find((model) => model.name === this.selectedModel);
    return model?.colors ?? [];
  },
  handleSubmit(event) {
    const formData = new URLSearchParams(new FormData(event.target));

    this.isLoading = true;

    fetch("https://forms.super73.com/pages/formprocessing", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
      body: formData,
    })
      .then((response) => response.json())
      .then(() => {
        this.isLoading = false;
        this.didSubmit = true;

        event.target.reset();

        setTimeout(() => {
          this.didSubmit = false;
        }, 6000);
      })
      .catch(() => {
        this.isLoading = false;
      });
  },
  init() {
    const models = JSON.parse(document.querySelector("script#form--product-registration-data").innerText);

    this.models = models.map((m) => ({
      ...m,
      colors: m.colors
        .split(",")
        .map((c) => c.trim())
        .filter(Boolean),
    }));
  },
});

export default ProductRegistrationForm;
